import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarkedAlt } from '@fortawesome/free-solid-svg-icons';
import InternalShell, { useInternalApi } from '../layouts/InternalShell';
import { BIZDEV_NAV } from './nav';

const Territory: React.FC = () => {
    const { api } = useInternalApi();
    const [counties, setCounties] = useState<any[]>([]);
    const [summary, setSummary] = useState<any>(null);
    const [loading, setLoading] = useState(true);
    const [onlyGaps, setOnlyGaps] = useState(false);

    useEffect(() => { document.title = 'Market Coverage - Uzima Internal'; }, []);
    useEffect(() => {
        api.get('bizdev-api/territory/').then(r => {
            if (r.data?.status === 'success') {
                setCounties(r.data.data.counties || []);
                setSummary(r.data.data.summary);
            }
        }).finally(() => setLoading(false));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const shown = onlyGaps ? counties.filter(c => !c.has_presence) : counties;

    return (
        <InternalShell activeDashboard="business_development" subNav={BIZDEV_NAV}>
            <h2 className="fw-bold mb-1"><FontAwesomeIcon icon={faMapMarkedAlt} className="me-2 text-primary" />Market & Territory Coverage</h2>
            <p className="text-muted mb-4">Where we have presence, county by county</p>

            {loading || !summary ? (
                <div className="text-center py-5"><div className="spinner-border text-primary" role="status"><span className="visually-hidden">Loading...</span></div></div>
            ) : (
                <>
                    <div className="row mb-4">
                        <div className="col-md-3 mb-3"><div className="card border-0 shadow-sm"><div className="card-body">
                            <div className="text-muted small mb-1">Coverage</div>
                            <h3 className={summary.coverage_pct >= 50 ? 'text-success' : 'text-warning'}>{summary.coverage_pct}%</h3>
                        </div></div></div>
                        <div className="col-md-3 mb-3"><div className="card border-0 shadow-sm"><div className="card-body">
                            <div className="text-muted small mb-1">Counties with presence</div><h4 className="text-success">{summary.with_presence}</h4>
                        </div></div></div>
                        <div className="col-md-3 mb-3"><div className="card border-0 shadow-sm"><div className="card-body">
                            <div className="text-muted small mb-1">Counties without</div><h4 className="text-warning">{summary.without_presence}</h4>
                        </div></div></div>
                        <div className="col-md-3 mb-3"><div className="card border-0 shadow-sm"><div className="card-body">
                            <div className="text-muted small mb-1">Total counties</div><h4>{summary.total_counties}</h4>
                        </div></div></div>
                    </div>

                    <div className="form-check mb-3">
                        <input className="form-check-input" type="checkbox" id="gaps" checked={onlyGaps} onChange={(e) => setOnlyGaps(e.target.checked)} />
                        <label className="form-check-label" htmlFor="gaps">Show only counties with no presence</label>
                    </div>

                    <div className="card border-0 shadow-sm">
                        <div className="card-body p-0">
                            <table className="table table-hover align-middle mb-0">
                                <thead className="table-light"><tr><th>County</th><th>Towns</th><th>Institutions</th><th>Practitioners</th><th>Open leads</th><th>Status</th></tr></thead>
                                <tbody>
                                    {shown.map(c => (
                                        <tr key={c.county} className={!c.has_presence ? 'table-light' : ''}>
                                            <td><strong>{c.county}</strong></td>
                                            <td>{c.towns}</td>
                                            <td>{c.institutions}</td>
                                            <td>{c.practitioners}</td>
                                            <td>{c.open_leads > 0 ? <span className="badge bg-info">{c.open_leads}</span> : '—'}</td>
                                            <td>{c.has_presence
                                                ? <span className="badge bg-success">Present</span>
                                                : <span className="badge bg-secondary">No presence</span>}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </>
            )}
        </InternalShell>
    );
};

export default Territory;
